import { SubText } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { Price } from '@webapp/core/components/Price'
import { makeSelectBaseCurrency } from '@webapp/core/stores/global'
import { formatDecimals } from '@webapp/core/utils/formatDecimals'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Currency } from '@webapp/models'
import messages from './messages'
import { CurrencyConversionInfoStyled } from './styles/CurrencyConversionInfoStyled'

export interface ICurrencyConversionInfoProps {
  currency: Currency
  price: number | string
}

export const CurrencyConversionInfo = ({
  currency,
  price,
}: ICurrencyConversionInfoProps) => {
  const intl = useProcurifyIntl()
  const baseCurrency = useSelector(makeSelectBaseCurrency())

  const convertedPrice = formatDecimals(price, true)
    .times(currency.rate)
    .toNumber()

  return (
    <CurrencyConversionInfoStyled>
      <CostSummary>
        <CostSummary.Cost>
          <th>
            <SubText>{intl.formatMessage(messages.exchangeRateLabel)}</SubText>
          </th>
          <td>
            <SubText>{currency.rate}</SubText>
          </td>
        </CostSummary.Cost>
        <CostSummary.Total>
          <th />
          <td>
            <Price currency={baseCurrency.name} price={convertedPrice} />
          </td>
        </CostSummary.Total>
      </CostSummary>
    </CurrencyConversionInfoStyled>
  )
}

CurrencyConversionInfo.displayName = 'CurrencyConversionInfo'
